var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// ../utils.ts
var isBrowser = () => typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.navigator !== "undefined";
var IS_BROWSER = isBrowser();
var AGENT = IS_BROWSER ? navigator.userAgent : "";
var IS_ANDROID = /android/i.test(AGENT);
var IS_FIREFOX = /firefox/i.test(AGENT);
var IS_IOS = /iPad|iPhone|iPod/.test(AGENT);
var _a;
var IS_MAC = IS_BROWSER && // @ts-expect-error Typescript has not implemented userAgentData yet https://stackoverflow.com/a/71392474
/^Mac/i.test(((_a = navigator.userAgentData) == null ? void 0 : _a.platform) || navigator.platform);
var SUPPORTS_CONSTRUCTED_CSS = IS_BROWSER && window.CSSStyleSheet && document.adoptedStyleSheets;
var EVENT_ONCE = { once: true, capture: true, passive: true };
var DISPLAY_BLOCK = ":host(:not([hidden])) { display: block }";
var FOCUS_OUTLINE = `outline: 1px dotted; outline: 5px auto Highlight; outline: 5px auto -webkit-focus-ring-color`;
var SAFE_MULTISELECTABLE = `${IS_ANDROID ? "data" : "aria"}-multiselectable`;
var UHTMLElement = typeof HTMLElement === "undefined" ? class {
} : HTMLElement;
var attr = (el, name, value) => {
  if (value === void 0) return el.getAttribute(name);
  if (value === null) el.removeAttribute(name);
  else if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  return null;
};
var on = (el, ...rest) => {
  const [types, ...options] = rest;
  for (const type of types.split(" ")) el.addEventListener(type, ...options);
  return () => off(el, ...rest);
};
var off = (el, ...rest) => {
  const [types, ...options] = rest;
  for (const type of types.split(" ")) el.removeEventListener(type, ...options);
};
var attachStyle = (el, css) => {
  const root = el.shadowRoot || el.attachShadow({ mode: "open" });
  if (!root.querySelector("slot")) root.append(tag("slot"));
  if (!root.querySelector("style")) {
    if (!SUPPORTS_CONSTRUCTED_CSS) root.append(tag("style", null, css));
    else {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(css);
      root.adoptedStyleSheets = [sheet];
    }
  }
  return root;
};
var onMutation = (el, callback, options) => {
  const observer = new MutationObserver((records) => {
    if (!isBrowser() || !el.isConnected) return cleanup();
    callback(el, records);
  });
  const cleanup = Object.assign(() => observer.disconnect(), {
    takeRecords: () => observer.takeRecords()
    // Expose takeRecords - useful if mutating a attribute that is observed
  });
  callback(el);
  observer.observe(el, options);
  return cleanup;
};
var getRoot = (node) => {
  var _a2;
  const root = ((_a2 = node.getRootNode) == null ? void 0 : _a2.call(node)) || node.ownerDocument;
  return root instanceof Document || root instanceof ShadowRoot ? root : document;
};
var getFocusedElement = (node) => getRoot(node).activeElement;
var getInputLabel = (el) => {
  var _a2;
  const label = attr(el, "aria-label") || "";
  const labels = ((_a2 = attr(el, "aria-labelledby")) == null ? void 0 : _a2.split(" ")) || [];
  return [
    ...labels.map((id) => document.getElementById(id.trim() || "-")),
    // Get all labelledby elements
    ...Array.from(el.labels || [])
    // Get all <label> elements
  ].reduce((acc, el2) => {
    var _a3;
    return acc || ((_a3 = el2 == null ? void 0 : el2.innerText) == null ? void 0 : _a3.trim()) || "";
  }, label).trim();
};
var useId = (el) => {
  if (!el || !IS_BROWSER) return null;
  if (!window.uElementsId) window.uElementsId = {};
  if (!el.id) {
    const node = el.nodeName.toLowerCase();
    if (!window.uElementsId[node]) window.uElementsId[node] = 1;
    el.id = `:${node}${window.uElementsId[node]++}`;
  }
  return el.id;
};
var tag = (tagName, attrs, content) => {
  const el = document.createElement(tagName);
  if (content) el.textContent = content;
  if (attrs) for (const [key, val] of Object.entries(attrs)) attr(el, key, val);
  return el;
};
var customElements = {
  define: (name, instance) => !isBrowser() || window.customElements.get(name) || window.customElements.define(name, instance)
};
var setValue = (input, data, type = "") => {
  var _a2, _b;
  const event = { bubbles: true, composed: true, data, inputType: type };
  const proto = HTMLInputElement.prototype;
  input.dispatchEvent(new InputEvent("beforeinput", event));
  (_b = (_a2 = Object.getOwnPropertyDescriptor(proto, "value")) == null ? void 0 : _a2.set) == null ? void 0 : _b.call(input, data);
  input.dispatchEvent(new InputEvent("input", event));
  input.dispatchEvent(new Event("change", { bubbles: true }));
};
var IS_PRESS = /* @__PURE__ */ new WeakSet();
var isPointerDown = (el, e) => {
  if ((e == null ? void 0 : e.type) === "pointerdown") {
    IS_PRESS.add(el);
    on(document, "pointerup", () => IS_PRESS.delete(el), EVENT_ONCE);
  }
  return IS_PRESS.has(el);
};
var declarativeShadowRoot = (style, slot = "<slot></slot>") => `<template shadowrootmode="open">${slot}<style>${style}</style></template>`;
var preventSubmit = (input) => {
  const form = attr(input, "form");
  attr(input, "form", "#");
  setTimeout(restoreSubmit, 0, input, form);
};
var restoreSubmit = (input, form) => attr(input, "form", form);
var getText = (el) => {
  var _a2;
  return ((_a2 = el == null ? void 0 : el.textContent) == null ? void 0 : _a2.trim()) || "";
};
var LIVE;
var LIVE_SR_FIX = 0;
var LIVE_CLEAR = 0;
var speak = (text) => {
  clearTimeout(LIVE_CLEAR);
  if (!LIVE) {
    LIVE = tag("div", { "aria-live": "assertive" });
    LIVE.style.overflow = "hidden";
    LIVE.style.position = "fixed";
    LIVE.style.whiteSpace = "nowrap";
    LIVE.style.width = "1px";
  }
  if (!LIVE.isConnected) document.body.append(LIVE);
  if (text === "") LIVE.textContent = "";
  if (text) {
    LIVE.textContent = `${text}${LIVE_SR_FIX++ % 2 ? "\xA0" : ""}`;
    LIVE_CLEAR = setTimeout(speak, !IS_MAC && IS_FIREFOX ? 2e3 : 300, "");
  }
};

// u-combobox.ts
var UHTMLComboboxStyle = `${DISPLAY_BLOCK}
:is(:host(:not([data-multiple])), :host([data-multiple="false"])) [part="items"] { display: none }
[role="listbox"] { display: inline-flex } /* Can not be "contents" as this confuses VoiceOver */
::slotted(button[type="reset"]),
::slotted(button[aria-expanded]),
::slotted(del) { font: inherit; border: 0; padding: 0; background: none; color: inherit; cursor: pointer; text-decoration: none }
::slotted(data) { cursor: pointer; pointer-events: none }
::slotted(data)::after { padding-inline: .5ch; pointer-events: auto }
::slotted(data)::after,
::slotted(del:empty)::before,
::slotted(button[type="reset"]:empty)::before { content: '\\00D7'; content: '\\00D7' / '' }
::slotted(button[aria-expanded="false"]:empty)::before { content: '\\25BC'; content: '\\25BC' / '' }
::slotted(button[aria-expanded="true"]:empty)::before { content: '\\25B2'; content: '\\25B2' / '' }
::slotted(data:focus),::slotted(del:focus),::slotted(button[type="reset"]:focus) { ${FOCUS_OUTLINE} }`;
var UHTMLComboboxShadowRoot = declarativeShadowRoot(UHTMLComboboxStyle);
var IS_LIST_HIDDEN = false;
var ARIA_LABEL = "aria-label";
var CSS_CLEAR = `button[type="reset"],del`;
var CSS_TOGGLE = `button[aria-expanded]`;
var CSS_DATALIST = `datalist,u-datalist,[role="listbox"]`;
var CSS_OPTION = `option,u-option,[role="option"]`;
var EVENTS = "blur focus click input keydown pointerdown";
var FALSE = "false";
var TEXTS = {
  added: "Added",
  clear: "Clear input",
  empty: "No selected",
  found: "Navigate left to find %d selected",
  invalid: "Invalid value",
  items: "Selected",
  // Note: Not announced by NVDA
  of: "of",
  remove: "Press to remove",
  removed: "Removed",
  toggle: "Options"
};
var UHTMLComboboxElement = class extends UHTMLElement {
  constructor() {
    super();
    this._focusMoved = false;
    // Used to determine if we announce through aria-live or aria-label when items are added or removed
    this._itemSingleVale = "";
    // Used to store current match
    this._speak = "";
    this._texts = __spreadValues({}, TEXTS);
    this._value = "";
    const root = attachStyle(this, UHTMLComboboxStyle);
    this._listbox = root.querySelector('[role="listbox"]') || tag("div");
    this._listbox.innerHTML = `<slot name="items"></slot>`;
    attr(this._listbox, "aria-orientation", "horizontal");
    attr(this._listbox, "role", "listbox");
    attr(this._listbox, "part", "items");
    attr(this._listbox, "tabindex", "-1");
    root.prepend(this._listbox);
  }
  // Locally store value to store value before input-click
  static get observedAttributes() {
    return Object.keys(TEXTS).map((key) => `data-sr-${key}`);
  }
  connectedCallback() {
    on(this, EVENTS, this, true);
    this._umutate = onMutation(this, onMutations, {
      attributeFilter: ["id", "value", "role", "aria-expanded"],
      // Respond to changes in <data> value or id or role of <datalist>
      attributes: true,
      characterData: true,
      // Respond to changes in <data> textContent
      childList: true,
      subtree: true
    });
    syncInputWithItemSingleMode(this);
    syncButtonsWithInput(this);
  }
  attributeChangedCallback(prop, _, val) {
    const text = prop.split("data-sr-")[1];
    if (TEXTS[text]) this._texts[text] = val || TEXTS[text];
    if (text === "clear" && this.clear)
      attr(this.clear, ARIA_LABEL, this._texts.clear);
  }
  disconnectedCallback() {
    var _a2;
    off(this, EVENTS, this, true);
    (_a2 = this._umutate) == null ? void 0 : _a2.call(this);
    this._umutate = this._clear = this._toggle = void 0;
    this._control = this._match = this._select = void 0;
    this._options = this._items = this._list = void 0;
  }
  handleEvent(event) {
    var _a2, _b, _c;
    if (((_a2 = this.control) == null ? void 0 : _a2.disabled) || ((_b = this.control) == null ? void 0 : _b.readOnly)) return;
    if (event.type === "blur") onBlur(this);
    if (event.type === "click") onClick(this, event);
    if (event.type === "focus") speak();
    if (event.type === "input") onInput(this, event);
    if (event.type === "keydown") onKeyDown(this, event);
    if (event.type === "pointerdown") {
      IS_LIST_HIDDEN = !!((_c = this.list) == null ? void 0 : _c.hidden);
      isPointerDown(this, event);
    }
  }
  get multiple() {
    var _a2;
    return ((_a2 = attr(this, "data-multiple")) != null ? _a2 : FALSE) !== FALSE;
  }
  set multiple(value) {
    attr(this, "data-multiple", value ? "" : null);
  }
  get creatable() {
    var _a2;
    return ((_a2 = attr(this, "data-creatable")) != null ? _a2 : FALSE) !== FALSE;
  }
  set creatable(value) {
    attr(this, "data-creatable", value ? "" : null);
  }
  get control() {
    var _a2;
    if (!((_a2 = this._control) == null ? void 0 : _a2.isConnected))
      this._control = this.querySelector("input");
    return this._control;
  }
  get list() {
    var _a2;
    if (!((_a2 = this._list) == null ? void 0 : _a2.isConnected)) {
      this._list = this.querySelector(CSS_DATALIST);
      this._options = void 0;
    }
    return this._list;
  }
  get clear() {
    var _a2;
    if (!((_a2 = this._clear) == null ? void 0 : _a2.isConnected)) this._clear = this.querySelector(CSS_CLEAR);
    return this._clear;
  }
  get toggle() {
    var _a2;
    if (!((_a2 = this._toggle) == null ? void 0 : _a2.isConnected))
      this._toggle = this.querySelector(CSS_TOGGLE);
    return this._toggle;
  }
  get items() {
    if (!this._items) this._items = this.getElementsByTagName("data");
    return this._items;
  }
  get options() {
    var _a2, _b, _c;
    const el = !this._options && ((_b = (_a2 = this.list) == null ? void 0 : _a2.querySelector(CSS_OPTION)) == null ? void 0 : _b.nodeName);
    if (el) this._options = (_c = this.list) == null ? void 0 : _c.getElementsByTagName(el);
    return this._options || this.getElementsByTagName("-");
  }
  get values() {
    return Array.from(this.items, ({ value }) => value);
  }
};
var dispatchMatch = (self) => {
  var _a2;
  const { creatable, control, options, multiple } = self;
  const value = ((_a2 = control == null ? void 0 : control.value) == null ? void 0 : _a2.trim()) || "";
  const query = value.toLowerCase() || null;
  let match = [...options].find(
    (o) => getLabel(o).trim().toLowerCase() === query
  );
  const event = { bubbles: true, cancelable: true, detail: match };
  if (!self.dispatchEvent(new CustomEvent("comboboxbeforematch", event)))
    match = [...options].find(getSelected);
  if (!multiple) for (const o of options) setSelected(o, o === match);
  else syncOptionsWithItems(self);
  if (!match && creatable && value) return { value, label: value };
  return match && { value: getValue(match), label: getLabel(match) };
};
var dispatchSelect = (self, item, canRemove = true) => {
  const { _texts, control, items, multiple } = self;
  if (!item) {
    if (multiple) return speak(_texts.invalid);
    if (!(control == null ? void 0 : control.value) && items[0]) return dispatchSelect(self, items[0]);
    return syncInputWithItemSingleMode(self);
  }
  const index = [...items].findIndex((i) => i.value === item.value);
  const remove = items[index];
  const focus = remove === getFocusedElement(self) && (multiple ? items[index - 1] || items[index + 1] || control : control);
  if (remove && !canRemove) return syncInputWithItemSingleMode(self);
  if (focus) focus.focus();
  self._focusMoved = !!focus;
  const add = tag("data", { value: item.value }, item.label || item.value);
  const event = { bubbles: true, cancelable: true, detail: remove || add };
  if (self.dispatchEvent(new CustomEvent("comboboxbeforeselect", event))) {
    if (!multiple) for (const item2 of [...items]) item2.remove();
    if (remove) remove.remove();
    else control == null ? void 0 : control.insertAdjacentElement("beforebegin", add);
    self.dispatchEvent(new CustomEvent("comboboxafterselect", event));
  }
};
var onBlur = (self) => isPointerDown(self) || setTimeout(onBlurred, 0, self);
var onBlurred = (self) => self.multiple || self.contains(getFocusedElement(self)) || dispatchSelect(self, self._match, false);
var onClick = (self, event) => {
  const { clientX: x, clientY: y, target } = event;
  const { clear, control, items, toggle } = self;
  if (toggle == null ? void 0 : toggle.contains(target)) {
    control == null ? void 0 : control.focus();
    IS_LIST_HIDDEN && (control == null ? void 0 : control.click());
  }
  if (control && (clear == null ? void 0 : clear.contains(target))) {
    event.preventDefault();
    setValue(control, "", "deleteContentBackward");
    control.focus();
    return IS_LIST_HIDDEN || control.click();
  }
  for (const item of items) {
    if (item.contains(target)) return dispatchSelect(self, item);
    const rect = item.getBoundingClientRect();
    const { top: t, right: r, bottom: b, left: l, width: w, height: h } = rect;
    if (w && h && y >= t && y <= b && x >= l && x <= r) return item.focus();
  }
  if (target === self) control == null ? void 0 : control.focus();
};
var onInput = (self, event) => {
  var _a2;
  const { control, options, multiple } = self;
  const value = (control == null ? void 0 : control.value) || null;
  const isDatalistClick = event instanceof InputEvent ? !event.inputType || event.inputType === "insertReplacementText" : !!(control == null ? void 0 : control.value);
  if (!isDatalistClick) self._value = (control == null ? void 0 : control.value) || "";
  if (isDatalistClick) {
    (_a2 = event.stopImmediatePropagation) == null ? void 0 : _a2.call(event);
    const clicked = [...options].find((o) => getValue(o) === value);
    if (control) control.value = self._value;
    if (clicked) return dispatchSelect(self, clicked, multiple);
  } else if (!multiple) self._match = dispatchMatch(self);
  syncButtonsWithInput(self);
};
var onKeyDown = (self, e) => {
  if (e.ctrlKey || e.metaKey || e.shiftKey || e.key === "Alt") return;
  if (self.control === e.target) onKeyDownControl(self, e);
  else onKeyDownItems(self, e);
};
var onKeyDownControl = (self, e) => {
  var _a2;
  const { _match, clear, control: input, items, multiple } = self;
  if ((e.key === "ArrowLeft" || e.key === "Backspace") && !(input == null ? void 0 : input.selectionEnd)) {
    (_a2 = items[items.length - 1]) == null ? void 0 : _a2.focus();
    e.preventDefault();
  }
  if (e.key === "Enter" && input) {
    preventSubmit(input);
    dispatchSelect(self, multiple ? dispatchMatch(self) : _match, multiple);
  }
  if (e.key === "Tab" && !e.shiftKey && clear && !clear.hidden) {
    e.preventDefault();
    attr(clear, "aria-hidden", "false");
    attr(clear, "tabindex", "0");
    clear.focus();
    on(clear, "blur", () => syncButtonsWithInput(self), EVENT_ONCE);
  }
};
var onKeyDownItems = (self, event) => {
  var _a2, _b, _c;
  const { clear, control, items } = self;
  const { key, repeat, target } = event;
  const index = [...items].indexOf(target);
  const isKeyClick = key === " " || key === "Enter";
  if (isKeyClick && (items[index] || target === clear)) {
    (_a2 = items[index] || clear) == null ? void 0 : _a2.click();
    return event.preventDefault();
  }
  if (!items[index]) return;
  if (key.startsWith("Arrow")) event.preventDefault();
  if (key === "ArrowLeft") return (_b = items[index - 1]) == null ? void 0 : _b.focus();
  if (key === "ArrowRight") return (_c = items[index + 1] || control) == null ? void 0 : _c.focus();
  if (key === "Backspace") {
    event.preventDefault();
    return repeat || dispatchSelect(self, items[index]);
  }
  control == null ? void 0 : control.focus();
};
var onMutations = (self, edit) => {
  var _a2;
  if (!self.control) return;
  const { _texts, control, items, list, multiple, toggle } = self;
  const edits = [];
  for (const { addedNodes: add, removedNodes: del } of edit || []) {
    for (const el of add) if (el instanceof HTMLDataElement) edits.unshift(el);
    for (const el of del) if (el instanceof HTMLDataElement) edits.push(el);
  }
  const focus = getFocusedElement(self);
  const doSpeak = multiple ? edits.length === 1 : edits[0] === focus;
  if (doSpeak && self.contains(focus)) {
    const label = control ? attr(control, ARIA_LABEL) : null;
    self._speak = `${_texts[edits[0].isConnected ? "added" : "removed"]} ${getText(edits[0])}, `;
    attr(control, ARIA_LABEL, `${self._speak}${getInputLabel(control)}`);
    if (!self._focusMoved) setTimeout(() => speak(self._speak.slice(0, -2)));
    setTimeout(speakReset, 300, self, label);
  }
  if (!multiple) {
    const item = getText(items[0]);
    if (item !== self._itemSingleVale) syncInputWithItemSingleMode(self);
    self._itemSingleVale = item;
  }
  syncItems(self);
  syncOptionsWithItems(self);
  syncSelectWithItems(self);
  if (toggle) attr(toggle, "aria-expanded", `${!(list == null ? void 0 : list.hidden)}`);
  const hint = `${items.length ? _texts.found.replace("%d", `${items.length}`) : _texts.empty}`;
  attr(control, "aria-description", multiple ? hint : null);
  attr(control, "list", useId(list));
  attr(self._listbox, ARIA_LABEL, _texts.items);
  (_a2 = self._umutate) == null ? void 0 : _a2.takeRecords();
};
var speakReset = (self, label) => {
  self._speak = "";
  if (self.control) attr(self.control, ARIA_LABEL, label);
  syncItems(self);
};
var syncItems = (self) => {
  const { _texts, _speak, items } = self;
  let idx = 0;
  for (const item of items) {
    const text = `${_speak}${getText(item)}, ${_texts.remove}${IS_IOS ? `, ${++idx} ${_texts.of} ${items.length}` : ""}`;
    attr(item, ARIA_LABEL, text);
    attr(item, "role", "option");
    attr(item, "slot", "items");
    attr(item, "tabindex", "-1");
    attr(item, "value", getValue(item));
  }
};
var syncSelectWithItems = (self) => {
  var _a2, _b;
  if (!((_a2 = self._select) == null ? void 0 : _a2.isConnected)) self._select = self.querySelector("select");
  if (!self._select) return;
  const { _select, items, multiple } = self;
  const append = [];
  let idx = 0;
  attr(_select, "multiple", multiple ? "" : null);
  for (const item of items) {
    const option = _select == null ? void 0 : _select.options[idx++];
    const text = getText(item);
    const value = getValue(item);
    if (!option) append.push(new Option(text, value, true, true));
    else
      Object.assign(option, {
        defaultSelected: true,
        selected: true,
        text,
        value
      });
  }
  if (append.length) _select.append(...append);
  else for (const opt of [..._select.options].slice(idx)) opt.remove();
  (_b = self._umutate) == null ? void 0 : _b.takeRecords();
};
var syncButtonsWithInput = (self) => {
  const { clear, control, toggle } = self;
  const hidden = !(control == null ? void 0 : control.value) || (control == null ? void 0 : control.disabled) || (control == null ? void 0 : control.readOnly);
  if ((clear == null ? void 0 : clear.nodeName) === "DEL") attr(clear, "role", "button");
  if (clear) {
    attr(clear, ARIA_LABEL) || attr(clear, ARIA_LABEL, self._texts.clear);
    attr(clear, "aria-hidden", `${IS_IOS || IS_ANDROID}`);
    attr(clear, "hidden", hidden ? "" : null);
    attr(clear, "tabindex", "-1");
  }
  if (toggle) {
    attr(toggle, ARIA_LABEL) || attr(toggle, ARIA_LABEL, self._texts.toggle);
    attr(toggle, "aria-hidden", `${IS_IOS || IS_ANDROID}`);
    attr(toggle, "hidden", hidden ? null : "");
    attr(toggle, "tabindex", "-1");
    attr(toggle, "type", "button");
  }
};
var syncOptionsWithItems = (self) => {
  if (!self.list) return;
  const { _texts, list, multiple, options, values } = self;
  attr(list, "data-sr-of", _texts.of);
  attr(list, SAFE_MULTISELECTABLE, `${multiple}`);
  for (const opt of options) setSelected(opt, values.includes(getValue(opt)));
};
var syncInputWithItemSingleMode = (self) => {
  if (!self.control || self.multiple) return;
  const { control, items } = self;
  const value = getText(items[0]);
  const action = value ? "insertText" : "deleteContentBackward";
  if (value !== control.value) setValue(control, value, action);
};
var getLabel = (el) => {
  var _a2;
  return (_a2 = attr(el, "label")) != null ? _a2 : getText(el);
};
var getValue = (el) => {
  var _a2;
  return (_a2 = attr(el, "value")) != null ? _a2 : getText(el);
};
var setSelected = (el, selected) => attr(el, "selected", selected ? "" : null);
var getSelected = (el) => {
  var _a2;
  return (_a2 = el.selected) != null ? _a2 : el.hasAttribute("selected");
};
customElements.define("u-combobox", UHTMLComboboxElement);

export { UHTMLComboboxElement, UHTMLComboboxShadowRoot, UHTMLComboboxStyle };
